import React from 'react';
import {
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

type Props = {
  audits: any[];
};

const statusColor = (
  status?: string
): 'success' | 'warning' | 'error' | 'default' => {
  const s = String(status || '').toLowerCase();
  if (s === 'success') return 'success';
  if (s === 'fallback') return 'warning';
  if (s === 'failure' || s === 'denied') return 'error';
  return 'default';
};

function formatTs(value?: string) {
  if (!value) return '-';
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? value : d.toLocaleString();
}

const AgentInvocationAuditTable: React.FC<Props> = ({ audits }) => {
  if (!audits.length) {
    return (
      <Typography variant="body2" color="text.secondary">
        No invocation history recorded.
      </Typography>
    );
  }

  return (
    <TableContainer sx={{ maxHeight: 420 }}>
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>Started</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Session</TableCell>
            <TableCell>Confidence</TableCell>
            <TableCell>Reason</TableCell>
            <TableCell>Error</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {audits.map((row, idx) => (
            <TableRow key={String(row.id || idx)} hover>
              <TableCell>{formatTs(row.started_at)}</TableCell>

              <TableCell>
                <Chip
                  size="small"
                  color={statusColor(row.status)}
                  label={String(row.status || 'unknown')}
                />
              </TableCell>

              <TableCell sx={{ maxWidth: 160, wordBreak: 'break-all' }}>
                {row.session_id || '-'}
              </TableCell>

              <TableCell>
                {row.classifier_confidence === null ||
                row.classifier_confidence === undefined
                  ? '-'
                  : Number(row.classifier_confidence).toFixed(2)}
              </TableCell>

              <TableCell sx={{ maxWidth: 220, wordBreak: 'break-word' }}>
                {row.selection_reason || '-'}
              </TableCell>

              <TableCell
                sx={{ maxWidth: 220, wordBreak: 'break-word', color: 'error.main' }}
              >
                {row.error_message || '-'}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AgentInvocationAuditTable;
